import liteguid from "lite-guid";
import { Store } from "./utils/Store";
export type Notification = {
	readonly type: "server-error" | "user-error" | "warning" | "info" | "success";
	readonly text: React.ReactNode;
	readonly timeout?: number;
	readonly dismissable?: boolean;
	readonly uuid?: string;
	readonly id: string; // the id is used for the selenium tag, and to deduplicate
};
export type NotificationHandle = {
	readonly dismiss: () => void;
};
export class NotificationStoreImpl extends Store {
	_notifications: Notification[];

	constructor() {
		super();
		this._notifications = [];
	}

	notify(notification: Notification): NotificationHandle {
		if (!notification.timeout) {
			this._notifications = this._notifications.filter(n => n.id !== notification.id);
		}

		this._notifications.push(notification);

		this.trigger();
		return {
			dismiss: () => this.dismiss(notification),
		};
	}

	dismiss(notification: Notification) {
		this._notifications = this._notifications.filter(value => value !== notification);
		this.trigger();
	}

	clear() {
		this._notifications = [];
		this.trigger();
	}

	get(): ReadonlyArray<Notification> {
		return this._notifications;
	}
}
export const NotificationStore: NotificationStoreImpl = new NotificationStoreImpl();
export function notify(notification: Notification): NotificationHandle {
	//the uuid is neccessary for the correct rendering of the animation
	if (notification.uuid) {
		return NotificationStore.notify(notification);
	}

	return NotificationStore.notify({ ...notification, uuid: liteguid.create() });
}
